export * from "./lib";
import { AxiosInstance } from "axios";
import { DefaultApiFactory } from "./lib/api";

export const purchaseApi = (axios: AxiosInstance) => {
  return DefaultApiFactory(undefined, "", axios);
};
